import { Text } from '@qonsoll/react-design'

import PropTypes from 'prop-types'
import { StyledAvatar } from './AvatarWithLetter.styled'
import { avatarLetterFromNameOrEmail } from 'helpers'
import { useTranslations } from 'contexts/Translation'

const AvatarWithLetter = ({ user, size }) => {
  /* Getting translations instance */
  const { t } = useTranslations()

  const avatarFirstLetter = avatarLetterFromNameOrEmail(
    user?.firstName,
    user?.email
  )
  return (
    <StyledAvatar
      shape="square"
      size={size || 200}
      alt={t('User avatar')}
      src={user?.avatarUrl}>
      <Text
        color="var(--ql-typography-text-color-secondary)"
        fontWeight="var(--ql-typography-heading-font-weight)"
        fontSize={[
          'var(--ql-font-size-avatar-sm)',
          'var(--ql-font-size-avatar-md)',
          'var(--ql-font-size-avatar-lg)',
          'var(--ql-font-size-avatar-xl)'
        ]}>
        {avatarFirstLetter}
      </Text>
    </StyledAvatar>
  )
}
AvatarWithLetter.propTypes = {
  user: PropTypes.object,
  size: PropTypes.number
}
export default AvatarWithLetter
